angular.module('businessThread')
    .component('businessThreadTimeline', {
        bindings: {
            thread: '<'
        },
        templateUrl: 'app/business-thread/timeline.html',
        controller: function ($state, $window, BusinessThread, BusinessThreadService, BusinessThreadLinkFlagService, BusinessThreadTimelineUi) {
            const defaultFilters = () => ({
                search: null,
                resourceType: null,
                dateFrom: null,
                dateTo: null,
                flags: [],
                showConfidential: false
            })
            const viewStateKey = () => BusinessThreadService.viewStateKey('timeline', this.thread && this.thread.id)

            this.items = []
            this.filteredItems = []
            this.resourceTypes = []
            this.resourceTypeCounts = {}
            this.flags = BusinessThreadLinkFlagService.flags
            this.filters = defaultFilters()
            this.activeFilters = false
            this.showResourceTypeFilter = true
            this.closeLabel = 'Wróć'
            this.loading = false

            this.$onInit = () => {
                let viewState = BusinessThreadService.getViewState(viewStateKey())
                this.filters = angular.extend(defaultFilters(), viewState.filters || {})
                this.load()
            }

            this.saveViewState = () => BusinessThreadService.saveViewState(viewStateKey(), {
                filters: this.filters
            })

            this.load = () => {
                if (!this.thread || !this.thread.id) {
                    return
                }

                this.saveViewState()
                this.loading = true
                return BusinessThread.timeline({
                    id: this.thread.id,
                    includeConfidential: this.filters.showConfidential === true
                }).$promise.then(items => {
                    this.items = items || []
                    this.resourceTypes = BusinessThreadTimelineUi.resourceTypes(this.items)
                    this.resourceTypeCounts = BusinessThreadTimelineUi.resourceTypeCounts(this.items)
                    this.applyFilters()
                }).finally(() => this.loading = false)
            }
            this.applyFilters = () => {
                this.saveViewState()
                this.activeFilters = BusinessThreadTimelineUi.hasActiveFilters(this.filters)
                this.filteredItems = BusinessThreadTimelineUi.filter(this.items, this.filters)
            }
            this.clearFilters = () => {
                this.filters = defaultFilters()
                this.saveViewState()
                this.load()
            }
            this.resourceLabel = BusinessThreadTimelineUi.resourceLabel
            this.resourceIcon = BusinessThreadTimelineUi.resourceIcon
            this.resourceTypeCount = type => this.resourceTypeCounts[type] || 0
            this.timelineEmptyText = () => 'Brak powiązanych rekordów'
            this.threadHref = () => BusinessThreadTimelineUi.threadHref(this.thread)
            this.openThread = event => {
                if (event && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) {
                    return
                }
                if (!this.thread || !this.thread.id) {
                    return
                }
                if (event) {
                    event.preventDefault()
                }
                return $state.go('businessThreadShowFull', {id: this.thread.id})
            }
            this.onResourceClick = angular.noop
            this.unlinkResource = item => {
                let unlink = BusinessThreadService.unlinkResource(item)
                return unlink && unlink.then ? unlink.then(() => this.load()).catch(angular.noop) : unlink
            }
            this.flagResource = (item, flag) => {
                let toggle = BusinessThreadLinkFlagService.toggleFlag(item, flag)
                return toggle && toggle.then ? toggle.then(() => this.load()).catch(angular.noop) : toggle
            }
            this.cancel = () => $window.history.back()
        }
    })
